import "./modules/nav.js";
import "./modules/hamburger.js";
import "./modules/headerAccordion.js";
import "./modules/search.js";
import "./modules/footer.js";
import "./modules/newsletter.js";

let wishlistReady = false
let wishlistLoad: Promise<void> | null = null

function loadWishlist(trigger: 'click' | 'preload'): Promise<void> {
  if (!wishlistLoad) {
    wishlistLoad = import("./modules/wishlist.js").then(({ initWishlist }) => {
      initWishlist({ trigger })
      wishlistReady = true
    }).catch((error) => {
      // Allow a later trigger to retry instead of reusing the rejected promise.
      wishlistLoad = null
      throw error
    })
  }
  return wishlistLoad
}

function deferToWishlist(e: Event): void {
  if (wishlistReady) return

  e.preventDefault()
  e.stopImmediatePropagation()

  // currentTarget is only set while the event is dispatching.
  const target = e.currentTarget as HTMLElement | null

  loadWishlist('click').then(() => {
    target?.click()
  }, () => {})
}

function bindWishlistTriggers(): void {
  document.querySelector(".js-open-wl")?.addEventListener("click", deferToWishlist, { capture: true })

  document.querySelectorAll(".ff-js-wl-add, .ff-js-later").forEach((el) => {
    el.addEventListener("click", deferToWishlist, { capture: true })
  })

  if (
    document.body.classList.contains("template-cart")
    || localStorage.getItem("ff_wishlist")
  ) {
    const preload = () => { loadWishlist('preload').catch(() => {}) }
    if ("requestIdleCallback" in window) {
      requestIdleCallback(preload, { timeout: 5000 })
    } else {
      setTimeout(preload, 3000)
    }
  }
}

bindWishlistTriggers();

(function() {
	const throttle = function(type: string, name: string, obj?: Document | Window) {
		obj = obj || window;
		let running = false;
		const func = function() {
			if (running) { return; }
			running = true;
			 requestAnimationFrame(function() {
				const event = new Event(name);
				obj.dispatchEvent(event);
				running = false;
			});
		};
		obj.addEventListener(type, func);
	};
	throttle("resize", "optimizedResize", window);
	throttle("scroll", "optimizedScroll", document);
})();
